import Item from './Item';
var RoamingStepperPlugin = /*@__PURE__*/ (function () {
    function RoamingStepperPlugin(element) {
        var _this = this;
        this.registerItems = function () {
            var that = _this;
            var elements = jQuery(_this.element).find('li.tg-item');
            for (var i = 0; i < elements.length; i++) {
                var itemElement = elements.eq(i).get(0);
                var item = new Item(itemElement);
                that.addItem(item);
            }
        };
        this.addItem = function (item) {
            _this.items.push(item);
        };
        this.initState = function () {
            _this.activeItem = -1;
            for (var _i = 0, _a = _this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                item.deactivate();
                item.disable();
            }
        };
        this.setActive = function (index) {
            var iterator = 0;
            for (var _i = 0, _a = _this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                if (iterator === index) {
                    item.activate();
                    item.enable();
                }
                else {
                    item.deactivate();
                    if (index < iterator) {
                        item.disable();
                    }
                    else {
                        item.enable();
                    }
                }
                iterator++;
            }
        };
        this.getItem = function (index) {
            return _this.items[index];
        };
        this.element = element;
        this.activeItem = -1;
        this.items = [];
        this.registerItems();
        this.initState();
    }
    return RoamingStepperPlugin;
}());
export default RoamingStepperPlugin;



//////////////////
// WEBPACK FOOTER
// ./app/bundles/appointman/app/ts/plugins/RoamingStepper/index.ts
// module id = null
// module chunks = 